export default "__VITE_ASSET__e3c8dd0e__"